module.exports = __webpack_public_path__ + "static/media/cancel.a641a952.png";